import React, { useEffect, useMemo, useState } from "react";
import {
    Alert,
    Box,
    CircularProgress,
    Paper,
    Typography,
} from "@mui/material";
import axios from "axios";

import HotelsMap from "../companies/Map";
import HotelsTable from "../companies/Table";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function LatestMembersPage() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            setLoading(true);
            setError("");
            try {
                const res = await axios.get(`${API_BASE}/api/filteredcompanies/latest`, {
                    withCredentials: true,
                });
                if (!cancelled) setRows(Array.isArray(res.data) ? res.data : []);
            } catch (e) {
                console.error("Latest members API error:", e);
                if (!cancelled) {
                    setRows([]);
                    setError("Neueste Mitglieder konnten nicht geladen werden.");
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();

        return () => {
            cancelled = true;
        };
    }, []);

    const markers = useMemo(() => {
        return (rows || [])
            .map((r) => {
                const lat = Number(r.lat);
                const lng = Number(r.lng);
                const hasPos = Number.isFinite(lat) && Number.isFinite(lng);

                return {
                    id: r.id,
                    name: r.name,
                    street: r.street,
                    zip: r.zip,
                    city: r.city,
                    country: r.country,
                    position: hasPos ? [lat, lng] : null,
                    startImage: r.start_image_url || null,
                    startImageCrop: r.start_image_crop || null,
                };
            })
            .filter((m) => Array.isArray(m.position));
    }, [rows]);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
                Neueste Mitglieder
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
                Die 20 zuletzt angelegten Firmen.
            </Typography>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <Paper sx={{ mb: 3, position: "relative", height: 600, overflow: "hidden" }}>
                <HotelsMap markers={markers} />

                {loading && (
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(229,231,235,0.9)",
                        }}
                    >
                        <Box sx={{ textAlign: "center" }}>
                            <CircularProgress sx={{ color: "var(--domain-primary)" }} />
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                Karte lädt...
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Paper>

            <Typography variant="h6" sx={{ mb: 1 }}>
                {rows.length} neueste Mitglieder.
            </Typography>

            <HotelsTable rows={rows} />
        </Box>
    );
}
